import { post, get } from '../util/crmAxios'
import { getBasicUrls } from '../util/config'

const schoolm = getBasicUrls().schoolm
// const schoolm = 'http://192.168.30.254:8082/api/'
// const api = "http://192.168.30.139:8080/api/crm/";

//学员推荐分页查询接口
export const getStudentList= (params) => post(schoolm + 'manage/youth/getStudentList', params);

// 新增/修改推荐学员信息
export const saveStudentVote= (params) => post(schoolm + 'manage/youth/saveStudentVote', params);

// 学员搜索下拉
export const queryStudentForCase = params => post(schoolm + 'manage/studentCase/queryStudentForCase', params)

// 学员推荐详情
export const getStudentVoteDetail = params => post(schoolm + 'manage/youth/getStudentVoteDetail', params)

// 学员推荐审核
export const submitStudentVote = params => post(schoolm + 'manage/youth/submitStudentVote', params)

// 撤回用户推荐
export const revertStudentVote = params => post(schoolm + 'manage/youth/revertStudentVote', params)

// 投票用户分页查询接口
export const getUserList= (params) => post(schoolm + 'manage/youth/getUserList', params);

//核销礼包
export const handleGift= (params) => post(schoolm + 'manage/youth/handleGift', params);


//查询销售推广数据列表
export const getSalePromoteList= (params) => post(schoolm + 'promote/getSalePromoteList', params);
// 导出销售推广数据
export const exportSalePromoteData = (params) => post(schoolm +'promote/exportPromoteData', params);
// 获取汇总信息
export const getPromoteSummaryInfo = (params) => post(schoolm +'promote/getPromoteSummaryInfo', params);

// 创建活动
export const savePromotion = (params) => post(schoolm +'manage/pmPromotion/savePromotion', params);

// 查询活动列表
export const queryPromotionList = (params) => post(schoolm +'manage/pmPromotion/queryPromotionList', params);

// 查询活动明细
export const queryPromotionDetail = (params) => post(schoolm +'manage/pmPromotion/queryPromotionDetail', params);

// 导出活动明细
export const exportPromotionDetail = (params) => post(schoolm +'manage/pmPromotion/exportPromotionDetail', params);

// 活动启动暂停
export const editPromotionStatus = (params) => post(schoolm +'manage/pmPromotion/editPromotionStatus', params);

// 查询助力明细
export const queryPromotionInvitedDetail = (params) => post(schoolm +'manage/pmPromotion/queryPromotionInvitedDetail', params);

// 获取转介绍活动列表页
export const getActivityList = (params) => post(schoolm +'manage/referral/getActivityList', params);

// 暂停转介绍活动
export const pauseActivity = (params) => post(schoolm +'manage/referral/pauseActivity', params);

// 启动转介绍活动
export const startActivity = (params) => post(schoolm +'manage/referral/startActivity', params);

// 活动投诉记录列表
export const activityBadRecord = (params) => post(schoolm +'manage/referral/activityBadRecord', params);

// 活动明细记录列表
export const activityDetailRecord = (params) => post(schoolm +'manage/referral/activityDetailRecord', params);

// 创建活动h5配置
export const addActivity = (params) => post(schoolm +'manage/referral/addActivity', params);


// 外呼服务-费用管理-订单查询
export const queryCallCenterList = (params) => post(schoolm +'manage/callCenter/order/list', params);

// 开通外呼服务弹窗-付款接口
export const payCallCenter = (params) => post(schoolm + 'manage/callCenter/order/pay', params);

// 费用管理-开通服务时的check逻辑
export const newOrderPrevCheck = (params) => post(schoolm + "manage/callCenter/order/newOrderPrevCheck", params);

// 费用管理-获取经销商话费消耗情况以及服务到期时间
export const getCampusPhoneBill = (params) => post(schoolm + "manage/callCenter/common/getCampusPhoneBill", params);

// 费用管理-服务续费-判断是否存在生效中的服务
export const checkCampusIsEffecting = (params) => post(schoolm + "manage/callCenter/order/checkCampusIsEffecting", params);

// 外呼服务续期订单付款接口
export const renewal = (params) => post(schoolm + "manage/callCenter/order/renewal", params);

// 外呼服务充值订单付款接口
export const recharge = (params) => post(schoolm + "manage/callCenter/order/recharge", params);

// 接收前端推送的通话事件数据
export const callEventLog = (params) =>
  post(schoolm + "manage/callCenter/order/callEventLog", params);

// 费用管理-获取经销商的自动续费标记
export const getAutoPayFlag = (params) => post(schoolm + "manage/callCenter/common/getAutoPayFlag", params);

// 费用管理-更新经销商的自动续费标记
export const chgAutoPayFlag = (params) => post(schoolm + "manage/callCenter/common/chgAutoPayFlag", params);

// 获取用户通话时是否需要进行温馨提示
export const getUserCallNoticeFlag = (params) =>
  post(schoolm + "manage/callCenter/common/getUserCallNoticeFlag", params);

// 更新用户通话时是否需要进行温馨提示
export const updUserCallNoticeFlag = (params) =>
  post(schoolm + "manage/callCenter/common/updUserCallNoticeFlag", params);

// 线索呼入时，提醒线索的跟进人
export const customCallInNotice = (params) =>
  post(schoolm + "manage/callCenter/common/customCallInNotice", params);

// 查询学校下拉
export const querySchoolDropdown = params => post(getBasicUrls().crm + 'crm/schoolexam/querySchoolDropdown', params)

// 查询学校考试信息
export const querySchoolExamInfo = (params) => post(getBasicUrls().crm +'crm/schoolexam/querySchoolExamInfo', params);

// 查询年份下拉
export const queryExamYearInfo = (params) => post(getBasicUrls().crm +'crm/schoolexam/queryExamYearInfo', params);

// 添加考试信息
export const addSchoolExamInfo = (params) => post(getBasicUrls().crm +'crm/schoolexam/addSchoolExamInfo', params);

// 查询单个学校考试信息
export const queryOneSchoolExamInfo = (params) => post(getBasicUrls().crm +'crm/schoolexam/queryOneSchoolExamInfo', params);

// 获取本地资料列表
export const queryLocalList = (params) => post(getBasicUrls().crm +'salesMaterial/material/localList', params);

// 获取资料信息
export const getLocalData = (params) => post(getBasicUrls().crm +'salesMaterial/material/get', params);


// 添加资料信息
export const addLocalData = (params) => post(getBasicUrls().crm +'salesMaterial/material/add', params);


// 编辑资料信息
export const updateLocalData = (params) => post(getBasicUrls().crm +'salesMaterial/material/update', params);


// 删除资料信息
export const deleteLocalData = (params) => post(getBasicUrls().crm +'salesMaterial/material/delete', params);


// 发布资料信息
export const publishLocalData = (params) => post(getBasicUrls().crm +'salesMaterial/material/publish', params);

// 取消发布资料信息
export const cancelPublishLocalData = (params) => post(getBasicUrls().crm +'salesMaterial/material/cancelPublish', params);

// 获取华为云OSS临时授权
export const getTemporaryAuto = (params) => post(getBasicUrls().crm +'salesMaterial/material/getTemporaryAuto', params);

// 获取目录
export const getMenuList = (params) => post(getBasicUrls().crm +'salesMaterial/catalog/list', params);

// 获取用户线索规则
export const getUserClueRule = (params) =>
  get(getBasicUrls().crm + "crm/rule/getUserClueRule", params);

// 更新用户线索规则
export const updateUserClueRule = (params) => post(getBasicUrls().crm +'crm/rule/updateUserClueRule', params);

// 获取标签信息
export const getClueTagConfig = (params) => get(getBasicUrls().crm +'crm/rule/getClueTagConfig', params);

// 增加或编辑标签/失效原因
export const addOrEditClueTag = (params) => post(getBasicUrls().crm +'crm/rule/addOrEditClueTag', params);

// 删除标签/失效原因
export const deleteClueTag = (params) => post(getBasicUrls().crm +'crm/rule/deleteClueTag', params);

// 开启/关闭线索规则/失效原因
export const openOrCloseTag = (params) => post(getBasicUrls().crm +'crm/rule/openOrCloseTag', params);

// 获取已开启标签信息
export const getEnableClueTagConfig = (params) => post(getBasicUrls().crm +'crm/rule/getEnableClueTagConfig', params);

// 获取渠道
export const getChannelSourceList = (params) => get(getBasicUrls().crm +'crm/rule/getChannelSourceList', params);

// 获取有效渠道
export const getEnableChannelSourceList = (params) => get(getBasicUrls().crm +'crm/rule/getEnableChannelSourceList', params);

// 增加或编辑渠道
export const addOrEditChannelSource = (params) => post(getBasicUrls().crm +'crm/rule/addOrEditChannelSource', params);

// 删除渠道
export const deleteChannelSource = (params) => post(getBasicUrls().crm +'crm/rule/deleteChannelSource', params);

// 开启或关闭渠道
export const openOrCloseChannelSource = (params) => post(getBasicUrls().crm +'crm/rule/openOrCloseChannelSource', params);

// 学校申请查询
export const querySchoolApplicationList = (params) => post(getBasicUrls().crm +'crm/schoolexam/querySchoolApply', params);

// 学校申请提交撤回
export const schoolApplyAudit = (params) => post(getBasicUrls().crm +'crm/schoolexam/schoolApplyAudit', params);

// 学校申请修改
export const applySchoolUpdate = (params) => post(getBasicUrls().crm +'crm/schoolexam/applySchoolUpdate', params);

// 学校申请详情
export const applySchoolInfo = (params) => post(getBasicUrls().crm +'crm/schoolexam/applySchoolInfo', params);

// 学校申请
export const applySchool = (params) => post(getBasicUrls().crm +'crm/schoolexam/applySchool', params);

// 学校信息修改申请列表查询
export const querySchoolGradeApply = (params) => post(getBasicUrls().crm +'crm/schoolexam/querySchoolGradeApply', params);

// 根据学校ID获取当前学段年级信息
export const getSchoolStageGradeInfo = (schoolId) => get(getBasicUrls().crm + 'crm/schoolexam/getSchoolStageGradeInfo?schoolId=' + schoolId);

// 提交学校信息修改申请
export const applySchoolGradeUpdate = (params) => post(getBasicUrls().crm + 'crm/schoolexam/applySchoolGradeUpdate', params);

// 根据申请ID获取学校信息修改申请详情
export const getSchoolGradeApplyDetail = (id) => get(getBasicUrls().crm + 'crm/schoolexam/getSchoolGradeApplyDetail?id=' + id);

// 撤销学校信息修改申请
export const revokeSchoolGradeApply = (id) => post(getBasicUrls().crm + 'crm/schoolexam/revokeSchoolGradeApply?id=' + id);
